import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { reactMarkdownComponents } from './ReactMarkDownComponents';

// Override paragraph to have tighter spacing for step descriptions
const StepDescriptionParagraph = ({ children }: { children?: React.ReactNode }) => (
  <span className="mb-1 block text-sm font-medium last:mb-0">{children}</span>
);

export function MarkdownStepDescription({ content, className = '' }: { content: string; className?: string }) {
  if (!content) {
    return null;
  }

  return (
    <div className={className}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{
          ...reactMarkdownComponents,
          p: StepDescriptionParagraph,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
